import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/kits-dinamicos',documento:'catalogs',acceso:'sesion',filas:['062'],cita:'Areas/Catalogs/Controllers/DynamicKitsController.cs:65'} satisfies RutaProd;
